import { render, staticRenderFns } from "./contract-liquid.vue?vue&type=template&id=26b785c9&scoped=true"
import script from "./contract-liquid.vue?vue&type=script&lang=js"
export * from "./contract-liquid.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=26b785c9&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b785c9",
  null
  
)

export default component.exports